import { render, staticRenderFns } from "./ProductDataStandard.vue?vue&type=template&id=767cd6ca&"
import script from "./ProductDataStandard.vue?vue&type=script&lang=js&"
export * from "./ProductDataStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports